import dayjs from 'dayjs';
// 引进utc插件
let utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}

/**
 * 1583045640458 => "2020年03月01日 星期日"
 * @param {number} value
 * @param {string} target
 * @param {boolean} dateDecimal
 * @param {boolean} timeDecimal
 */
export function formatTimestamp(value, target, dateDecimal, timeDecimal) {
  // if (isNaN(value)) return "未知";
  let date = new Date(value);
  let y = date.getFullYear(); // 1970 - ????
  let m = date.getMonth() + 1; // 0 - 11
  dateDecimal === false ? m : (m = m < 10 ? "0" + m : m);
  let d = date.getDate(); // 1 - 31
  dateDecimal === false ? d : (d = d < 10 ? "0" + d : d);
  let w = date.getDay(); // 0 - 6
  w = ["日", "一", "二", "三", "四", "五", "六"][w];
  let h = date.getHours();
  timeDecimal === false ? h : (h = h < 10 ? "0" + h : h);
  let min = date.getMinutes();
  timeDecimal === false ? min : (min = min < 10 ? "0" + min : min);
  let s = date.getSeconds();
  timeDecimal === false ? s : (s = s < 10 ? "0" + s : s);
  // 指定目标
  switch (target) {
    case "year": // 年
      return y;
    case "month": // 月
      return m;
    case "date": // 日
      return d;
    case "day": // 周
      return w;
    case "whichDay": // 周
      return `星期${w}`;
    case "HH:mm":
      return `${h}:${min}`;
    case "MM-dd":
      return `${m}月${d}日`;
    case "yyyy-MM-dd":
      return `${y}-${m}-${d}`;
    case "yyyy-MM-dd HH:mm":
      return `${y}-${m}-${d} ${h}:${min}`;
    case "yyyy-MM-dd HH:mm:ss": //
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    default:
      return `${y}年${m}月${d}日 星期${w}`;
  }
}

/**
 * 1586237281679 => "中午"
 * @param {number} value
 */
export function toTimeRange(value) {
  let timeLabel = "";
  let currentHour = new Date(value).getHours();
  switch (true) {
    case currentHour >= 3 && currentHour < 6:
      timeLabel = "凌晨好，";
      break;
    case currentHour >= 6 && currentHour < 8:
      timeLabel = "早晨好，";
      break;
    case currentHour >= 8 && currentHour < 11:
      timeLabel = "上午好，";
      break;
    case currentHour >= 11 && currentHour < 13:
      timeLabel = "中午好，";
      break;
    case currentHour >= 13 && currentHour < 17:
      timeLabel = "下午好，";
      break;
    case currentHour >= 17 && currentHour < 19:
      timeLabel = "傍晚好，";
      break;
    case currentHour >= 19 && currentHour < 23:
      timeLabel = "晚上好，";
      break;
    case currentHour >= 23 || currentHour < 3:
      timeLabel = "夜深了，注意休息。";
      break;
  }
  return timeLabel;
}

/**
 *  => ""
 * @param {number} str
 */
export function removeHTMLTag(str) {
  str = str.replace(/<\/?[^>]*>/g, ""); // 去除HTML tag
  str = str.replace(/[ | ]*\n/g, "\n"); // 去除行尾空白
  str = str.replace(/\n[\s| | ]*\r/g, "\n"); // 去除多余空行
  str = str.replace(/&nbsp;/gi, ""); // 去掉&nbsp;
  return str;
}
/**
 *  => ""
 * @param {string} formateStyle 日期格式化样式
 */
export function formatDate(value,formateStyle= 'YYYY-MM-DD HH:mm:ss',noDataVaule,timeMode){

  if(!value) return noDataVaule||'';
  if(timeMode && timeMode === 'utc') {
    return dayjs.utc(value).local().format(formateStyle);
  } else {
    return dayjs(value).format(formateStyle);
  }

}
